// extracted by mini-css-extract-plugin
export var layoutContainer = "_ax-0";
export var layoutContainerNoRounding = "_ax-6";
export var layoutContainerOpen = "_ax-5";
export var layoutContainerResizing = "_ax-1";
export var mainContent = "_ax-2";
export var resizeDivider = "_ax-3";
export var slidePanel = "_ax-4";